export const PHONE_MAX_SIZE = 600;
export const DESKTOP_MIN_SIZE = 993;
export const DRAWER_WIDTH = 230;
